import { z } from 'zod';

// zod v4 = Standard Schema → pass directly to validateSearch (no @tanstack/zod-adapter).
// `step` mirrors the wizard's current step (1-6) in the URL so it survives a
// refresh/back-button and is shareable. Garbage/out-of-range → undefined,
// which NewCampaign treats as step 1 (or the persisted draft's step).
export const newCampaignSearchSchema = z.object({
  step: z.coerce.number().int().min(1).max(6).optional().catch(undefined),
});

export type NewCampaignSearch = z.infer<typeof newCampaignSearchSchema>;
